/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Assign_Track_BInputs */



/**
* | output |
* | --- |
* | "Assign the selected event(s) to track B" |
*
* @param {Shortcut_Keys_Desc_Assign_Track_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_assign_track_b = /** @type {((inputs?: Shortcut_Keys_Desc_Assign_Track_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Assign_Track_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuez le ou les événements sélectionnés au suivi B.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weisen Sie die ausgewählten Ereignisse der Spur B zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna l'evento o gli eventi selezionati alla traccia B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначьте выбранное событие (события) для отслеживания B.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asigne el/los evento(s) seleccionado(s) a la pista B.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件分配给跟踪 B。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをトラックBに割り当てます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को ट्रैक B में असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribua o(s) evento(s) selecionado(s) à faixa B.")
	return /** @type {LocalizedString} */ ("Assign the selected event(s) to track B")
});